import * as ko from 'knockout'
import { DogStarterViewModel, Params } from './DogStarterViewModel'
import template from './dog.starter.tpl.html'

if (!ko.components.isRegistered('dog-starter')) {
  ko.components.register('dog-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new DogStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
